module.exports = __webpack_public_path__ + "img/credit_green_icon.8f15fa3f.svg";